import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Plus } from 'react-feather';
import {ApiDetails, KEY} from "../../Constants";

import CategoryList from './CategoryList';
import CategoryDialog from './CategoryDialog';
import CryptoJS from "crypto-js";
import { handle401Unauthorized, handle403Forbidden } from '../../utils/authErrorHandler';


const CategorySection = ({
    categories,
    problemTypes,
    getLandlordId,
    showAlert,
    onCategoriesUpdated
}) => {
    const [categoryDialogOpen, setCategoryDialogOpen] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
const [originalText, setOriginalText] = useState(() => {
    const encryptedData = localStorage.getItem("myMap");
    return encryptedData 
        ? CryptoJS.AES.decrypt(encryptedData, KEY).toString(CryptoJS.enc.Utf8)
        : "";
});;

    // Add or update category
    const handleSaveCategory = async (category, isNew) => {
        try {
            const landlordId = getLandlordId();
            if (!landlordId) return;

            const endpoint = isNew
                ? ApiDetails + "pegasus/visionary/tickets/api/tickets/problems/add"
                : ApiDetails + "pegasus/visionary/tickets/api/tickets/problems/update";

            const categoryData = {
                ...category,
                landlord_id: landlordId
            };

            const response = await fetch(endpoint, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "token": JSON.parse(originalText)[15][0] !== 'access_token' ? JSON.parse(originalText)[28][1] : JSON.parse(originalText)[15][1]
                },
                body: JSON.stringify(categoryData)
            });

             // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
            if (response.status === 200) {
                showAlert(isNew ? "Category added successfully" : "Category updated successfully");
                onCategoriesUpdated();
                setCategoryDialogOpen(false);
                setSelectedCategory(null);
            } else {
                throw new Error(`Error: ${response.status}`);
            }
        } catch (error) {
            console.error("Error saving category:", error);
            showAlert(isNew ? "Failed to add category" : "Failed to update category", "error");
        }
    };

    // Delete category
    const handleDeleteCategory = async (categoryId) => {
        try {
            const landlordId = getLandlordId();
            if (!landlordId) return;

            const response = await fetch(ApiDetails + "pegasus/visionary/tickets/api/tickets/problems/delete", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "token": JSON.parse(originalText)[15][0] !== 'access_token' ? JSON.parse(originalText)[28][1] : JSON.parse(originalText)[15][1]
                },
                body: JSON.stringify({
                    problem_id: categoryId,
                    landlord_id: landlordId
                })
            });

             // Handle authentication/authorization errors
                if (response.status === 401) {
                    handle401Unauthorized();
                    return;
                }
                if (response.status === 403) {
                    handle403Forbidden();
                    return;
                }
            if (response.status === 200) {
                showAlert("Category deleted successfully");
                onCategoriesUpdated();
            } else {
                throw new Error(`Error: ${response.status}`);
            }
        } catch (error) {
            console.error("Error deleting category:", error);
            showAlert("Failed to delete category", "error");
        }
    };

    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Typography variant="h6">Categories</Typography>
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<Plus size={16} />}
                    onClick={() => {
                        setSelectedCategory(null);
                        setCategoryDialogOpen(true);
                    }}
                    sx={{ borderRadius: '8px', textTransform: 'none' }}
                >
                    Add Category
                </Button>
            </Box>

            <CategoryList
                categories={categories}
                problemTypes={problemTypes}
                onEdit={(category) => {
                    setSelectedCategory(category);
                    setCategoryDialogOpen(true);
                }}
                onDelete={handleDeleteCategory}
            />

            <CategoryDialog
                open={categoryDialogOpen}
                category={selectedCategory}
                problemTypes={problemTypes}
                onClose={() => {
                    setCategoryDialogOpen(false);
                    setSelectedCategory(null);
                }}
                onSave={handleSaveCategory}
            />
        </Box>
    );
};

export default CategorySection;